<app-tva-custom-selection></app-tva-custom-selection>
<br />
<div class="row">
  <div id="grid-wrapper" style="width: 100%; height: 100%">
    <ag-grid-angular
      [domLayout]="'normal'"
      [style.height]="bookingsOverviewData.length > 20 ? '740px' : 'none'"
      [gridOptions]="gridOptions"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [context]="context"
      [multiSortKey]="multiSortKey"
      [components]="frameworkComponents"
      [getContextMenuItems]="getContextMenuItems"
      [tooltipShowDelay]="tooltipShowDelay"
      [enableBrowserTooltips]="true"
      [excelStyles]="excelStyles"
      (gridReady)="onGridReady($event)"
      class="ag-theme-alpine_customize"></ag-grid-angular>
  </div>
</div>

@if (isOverviewTabActive() && userHasAnyRight()) {
  <pas-sidebar-holder [hasNavbar]="true">
    <div class="sidebar-contents">
      <div class="sidebar-element sidebar-row">
        <ul class="navbar-nav">
          <!-- create manual booking -->
          @if (canUserCreateManualBooking()) {
            <li class="nav-item">
              <a (click)="onBtnCreateManualBooking()" class="nav-link link-sidebar">
                <i class="material-icons">add_circle_outline</i>
                <span class="hidden-md-down" ui-test-id="createBookingBtn">
                  {{ 'BOOKING_DETAILS_CREATE_MANUAL_BOOKING' | translate }}
                </span>
              </a>
            </li>
          }
          <li [ngClass]="isCreateExcelBookingEnabled ? 'nav-item' : 'nav-item disabled'">
            <a (click)="onBtnCreateExcelBooking()" class="nav-link link-sidebar">
              <i class="material-icons">get_app</i>
              <span class="hidden-md-down" ui-test-id="excelExportBtn">{{ 'EXCEL_EXPORT' | translate }}</span>
            </a>
          </li>
          <app-tva-custom-sidebar
            [numberOfButtonsVisibleSidebar]="numberOfButtonsVisibleSidebar"></app-tva-custom-sidebar>
        </ul>
      </div>
    </div>
  </pas-sidebar-holder>
}
